import { render } from "./ContactoModal.vue?vue&type=template&id=2daa4c90"
import script from "./ContactoModal.vue?vue&type=script&lang=js"
export * from "./ContactoModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__